<section class="google-workspace-productivity" id="idGoogleWorkspaceProductivity">
  <div class="box">
    <div class="box-heading">
      <div class="box-heading__title"
        ><span>{{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.TITLE' | translate }}</span></div
      >
      <div class="box-heading__detail"
        ><span>{{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.DETAIL' | translate }}</span></div
      >
      <div class="box-heading__package"
        ><span>{{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.PACKAGE' | translate }}</span></div
      >
      <div class="box-heading__icon">
        <ng-container *ngFor="let icon of iconsWorkspace">
          <img
            class="box-heading__icon--layout"
            loading="lazy"
            [src]="getImageUrl(icon.name)"
            [alt]="icon.name | translate"
          /> </ng-container
      ></div>
    </div>
    <div class="box-content desktop">
      <div class="box-content__left">
        <img
          class="box-content__left--img"
          src="https://flowaccountcdn.com/new_landing/image/google-workspace/productivity/google_workspace.png"
          alt="google workspace"
          loading="lazy"
        />
        <div class="box-content__left--text"
          ><span>{{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.PER_USER_DETAIL' | translate }}</span>
          <span>{{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.VAT_DETAIL' | translate }}</span></div
        >
      </div>
      <div class="box-content__right">
        <div class="box-content__right--popular"
          ><span class="popular-layout">{{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.MOST_POPULAR' | translate }}</span></div
        >
        <div class="box-content__right--price">
          <ng-container *ngFor="let item of pricePlans">
            <div class="price-pay">
              <div class="price-pay__title"
                ><span>Business {{ item.title }}</span></div
              >
              <div class="price-pay__discount">
                <ng-container *ngIf="item.discount">
                  <div class="price-pay__discount--left">
                    <span>฿</span><span>{{ item.discount }}</span></div
                  ><div class="price-pay__discount--right"
                    ><span>{{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.SAVE' | translate }}</span
                    ><span>{{ item.save }}</span></div
                  ></ng-container
                ></div
              >
              <div class="price-pay__cost">
                <div class="price-pay__cost--left">
                  <span>฿</span><span class="left-layout">{{ item.cost }}</span>
                </div>
                <div class="price-pay__cost--right"
                  ><span>{{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.USER_MONTH' | translate }}</span></div
                >
              </div>
              <div class="price-pay__annually"
                ><ng-container *ngIf="translate.currentLang === 'th'; else enLang">
                  <span>
                    {{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.ANNUAL_PAYMENT' | translate }}
                    {{ item.costAnnually }}
                    {{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.BAHT' | translate }}
                  </span>
                </ng-container>

                <ng-template #enLang>
                  <span>{{ item.costAnnually }} {{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.ANNUAL_PAYMENT' | translate }}</span>
                </ng-template>
              </div>
              <div class="price-pay__btn">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  class="price-pay__btn--layout {{ item.buttonClass }}"
                  [href]="'https://form.flowaccount.com/googleworkspace'"
                >
                  <span>{{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.BTN' | translate }}</span>
                </a>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="box-content mobile">
      <ng-container *ngFor="let item of pricePlans">
        <div
          class="box-content__navbar"
          (click)="selectPackage(item.title)"
          [ngClass]="{ active: typePackage === item.title }"
          ><span>{{ item.title }}</span>
          <div class="navbar-borderbottom" [ngClass]="{ active: typePackage === item.title }"></div>
        </div>
      </ng-container>
    </div>
    <div class="box-modifier mobile">
      <ng-container *ngFor="let item of pricePlans">
        <div class="box-modifier__price" [ngClass]="{ active: typePackage === item.title }">
          <div class="price-pay">
            <div class="price-pay__popular" [ngClass]="{ active: typePackage === 'Standard' }"
              ><span>{{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.MOST_POPULAR' | translate }}</span></div
            >
            <div class="price-pay__title"
              ><span>Business {{ item.title }}</span></div
            >
            <div class="price-pay__discount">
              <ng-container *ngIf="item.discount"
                ><div class="price-pay__discount--left">
                  <span>฿</span><span>{{ item.discount }}</span></div
                ><div class="price-pay__discount--right"
                  ><span>{{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.SAVE' | translate }}</span
                  ><span>{{ item.save }}</span></div
                ></ng-container
              ></div
            >
            <div class="price-pay__cost">
              <div class="price-pay__cost--left">
                <span>฿</span><span class="left-layout">{{ item.cost }}</span>
              </div>
              <div class="price-pay__cost--right"
                ><span>{{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.USER_MONTH' | translate }}</span></div
              >
            </div>
            <div class="price-pay__annually"
              ><ng-container *ngIf="translate.currentLang === 'th'; else enLang">
                <span>
                  {{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.ANNUAL_PAYMENT' | translate }}
                  {{ item.costAnnually }}
                  {{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.BAHT' | translate }}
                </span>
              </ng-container>

              <ng-template #enLang>
                <span>{{ item.costAnnually }} {{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.ANNUAL_PAYMENT' | translate }}</span>
              </ng-template>
            </div>
            <div class="price-pay__btn">
              <a
                class="price-pay__btn--layout {{ item.buttonClass }}"
                target="_blank"
                rel="noopener noreferrer"
                [href]="'https://form.flowaccount.com/googleworkspace'"
              >
                <span>{{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.BTN' | translate }}</span>
              </a>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="box-modifier__text"
        ><span>{{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.PER_USER_DETAIL' | translate }}</span>
        <span>{{ 'GOOGLE_WORKSPACE.PRODUCTIVITY.VAT_DETAIL' | translate }}</span>
      </div>
    </div>
    <div class="box-wrapper">
      <ng-container *ngFor="let item of contentData">
        <div class="box-wrapper__element">
          <div class="box-wrapper__element--heading"
            ><span>{{
              'GOOGLE_WORKSPACE.PRODUCTIVITY.CONTENT.' + item.heading.toUpperCase() + '.TITLE' | translate
            }}</span></div
          >
          <ng-container *ngFor="let item2 of item.content">
            <div class="box-wrapper__element--table">
              <div class="table-app">
                <div class="table-app__img">
                  <img
                    class="table-app__img--layout"
                    loading="lazy"
                    [src]="getImageUrl(item2.name)"
                    [alt]="item2.name | translate"
                /></div>
                <div class="table-app__text"
                  ><span>{{ item2.name }}</span></div
                >
              </div>
              <div class="table-detail">
                <ng-container *ngFor="let item3 of item2.detail; let index = index">
                  <div class="table-detail__element">
                    <div class="element-content">
                      <span>{{
                        'GOOGLE_WORKSPACE.PRODUCTIVITY.CONTENT.' +
                          item.heading.toUpperCase() +
                          '.DETAIL.' +
                          item2.name.toUpperCase() +
                          '.' +
                          (index + 1) | translate
                      }}</span></div
                    >
                    <div class="element-icon desktop">
                      <ng-container *ngFor="let icon of item3.check">
                        <div class="element-icon__list">
                          <div class="element-icon__list--layout"><span [innerHTML]="icon | translate"></span></div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="element-icon mobile">
                      <div class="element-icon__list" *ngIf="typePackage === 'Starter'">
                        <div class="element-icon__list--layout"
                          ><span [innerHTML]="item3.check[0] | translate"></span
                        ></div>
                      </div>
                      <div class="element-icon__list" *ngIf="typePackage === 'Standard'">
                        <div class="element-icon__list--layout"
                          ><span [innerHTML]="item3.check[1] | translate"></span
                        ></div>
                      </div>
                      <div class="element-icon__list" *ngIf="typePackage === 'Plus'">
                        <div class="element-icon__list--layout"
                          ><span [innerHTML]="item3.check[2] | translate"></span
                        ></div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
    <div class="box-remark">
      <div class="box-remark__text">
        <span [innerHTML]="'GOOGLE_WORKSPACE.PRODUCTIVITY.REMARK' | translate"></span>
      </div>
    </div>
  </div>
</section>
